import { TmcContextService } from './../../../../../../../common/tmc-context.service';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppClientConfigurationService } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { ResponseMessage } from '@sdbn/common';
import { DashboardContext } from '@sdbn/common';
import { Station } from '../../../../../../../client/model/station';
import { TMCClientParameters } from '@sdbn/tmc-common';
import { SacClientContext } from '../../../../model/sac-client.context';

import { TransportDetailsLayoutService } from '../../../../../../../components/transport-details/transport-details-layout.service';
import { StationSet } from '../../../../../../../client/model/station-set';
import { TransportDetailLayout, TransportDetailMode } from '../../../../../../../common/configuration/transport.configuration';
import { TransportDetailsLayoutConverter } from '../../../../../../../common/components/tmp/transport-details-layout-converter.service';
import { Transport } from '../../../../../../../common/model/transport.model';

@Component({
    selector: 'app-station-transport-details',
    templateUrl: './station-transport-details.component.html',
    styleUrls: ['./station-transport-details.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class StationTransportDetailsComponent implements OnInit {

  TransportDetailMode = TransportDetailMode;

  isLinkTransportsEnabled = true;

  clientParameters = TMCClientParameters;

  get isCallTransportToStationEnabled() {
    return this.transport.messaging.messagingAvailable && !this.isLoading;
  }

  layoutDefinition: TransportDetailLayout;

  isLoading = false;

  responseMessages: ResponseMessage[];

  @Input() dashboardContext: DashboardContext;

  sacClientContext: SacClientContext;
  @Input('sacClientContext') set setSacClientContext(sacClientContext: SacClientContext) {
    this.sacClientContext = sacClientContext;
  }

  @Input() station: Station;

  @Input() stationSet: StationSet;

  @Input() transport: Transport;

  yardConfigSubscription: Subscription;

  constructor(
    private transportDetailsLayoutService: TransportDetailsLayoutService,
    private tmcContextService: TmcContextService,
    public cps: AppClientConfigurationService,
    public translationService: TranslationService,
    transportDetailsLayoutConverter: TransportDetailsLayoutConverter
  ) {
    this.layoutDefinition = transportDetailsLayoutConverter.convert(
      this.transportDetailsLayoutService.createStationAssignmentStationDetailsGridLayout()
    );
    this.isLinkTransportsEnabled = cps.isPropertyTrue(TMCClientParameters.FEATURES_LINK_TRANSPORTS, false);
  }

  ngOnInit(): void {
  }

  handleChange() {
    this.tmcContextService.forceRefreshOfStationUsages();
  }

}
